import React, { Component } from 'react';

class SubmitButton extends Component {
  classNames = () => {
    let classes = this.props.className;
    if (this.props.loading) {
      classes += ' is-loading';
    }
    return classes;
  }

  render() {
    const { disabled, label } = this.props;

    return (
      <button className={this.classNames()} disabled={disabled}>{label}</button>
    );
  }
}

export default SubmitButton;
